import {
  useDataSubmit,
  useDataIsSubmitting,
  useDataValue,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'payers',
    viewPath: props.viewPath,
  })

  return function onClick(value) {
    submit({
      type: 'installment',
    })
  }
}

export function useIsDisabled(props) {
  let payment = useDataValue({
    context: 'payment',
    viewPath: props.viewPath,
  })
  let isSubmitting = useDataIsSubmitting({
    context: 'payers',
    viewPath: props.viewPath,
  })

  return (
    isSubmitting ||
    !payment.valid ||
    (payment.is_fee_applicable && !payment.is_fee_acknowledged)
  )
}
